import axios from "axios";

const appServiceName = process.env.REACT_APP_API_URL;

class RestfulProvider {
  constructor() {
    this.setCommonHeaders();
  }

  setCommonHeaders = () => {
    if (localStorage.getItem("user")) {
      const userDetail = JSON.parse(localStorage.getItem("user"));
      // console.log(userDetail);
      axios.defaults.headers["x-auth-token"] = userDetail.token;
    }
  };

  makeCall = (url, data, axiosMethod) => {
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (localStorage.getItem("token")) {
      this.setCommonHeaders();
    }

    return new Promise((resolve, reject) => {
      const response = axiosMethod(`${appServiceName}${url}`, data, header);

      response
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(
            error.response?.data.error ||
              "Server is down, please check after some time !!"
          );
        });
    });
  };

  put = (url, data) => {
    return this.makeCall(url, data, axios.put);
  };

  post = (url, data) => {
    return this.makeCall(url, data, axios.post);
  };

  get = (url) => {
    return this.makeCall(url, undefined, axios.get);
  };

  delete = (url, request) => {
    return this.makeCall(url, { data: request }, axios.delete);
  };
}

export default new RestfulProvider();
